import { AFTER_WELCOME_PARAM } from './welcomeSplash';

interface WelcomePageNavigateArgsParams {
  pathname: string;
  search: string;
}

export function welcomePageNavigateArgs({
  pathname,
  search
}: WelcomePageNavigateArgsParams): WelcomePageNavigateArgsParams {
  const resultSearch = new URLSearchParams(search);
  resultSearch.set(AFTER_WELCOME_PARAM, pathname);

  return { pathname: '/welcome', search: `?${resultSearch.toString()}` };
}
